import React from "react";
import { useAuth } from "react-uicomp";

export const Information = () => {
  const { language } = useAuth();
  return (
    <div className="Introduction-Information-wrapper">
      <div className="research">
        <div className="title">Our Goal</div>
        <div className="paragraph">
          <p>
            Contributing for the increased production and productivity of
            cereals and horticultural crops; and livestock commodities by
            technological supports through research and studies in the eastern
            hills of Nepal
          </p>
        </div>
      </div>
      <div className="research">
        <div className="title">Objectives</div>
        <div className="paragraph">
          <p>
            1. Developing technologies on cereals and horticultural crops; and
            livestock commodities suitable for the high hills, mid-hills and low
            hills/river basins.
            <br />
            2. Prioritizing research areas in the eastern hills.
            <br />
            3. Delivering technologies through effective outreach programs to
            increase the production and productivity of agriculture and
            livestock commodities.
            <br />
            4. Providing training, technical services and counseling to the
            farmers, agriculture extension organizations and other concerned
            line agencies.
            <br />
            5. Establishing and maintaining coordination and linkage with line
            agencies, local bodies and other stakeholders for the technology
            transfer and dissemination. <br />
          </p>
        </div>
      </div>
      <div className="research">
        <div className="title">Strategies</div>
        <div className="paragraph">
          <p>
            Generation of appropriate technologies and their effective delivery
            in various agro-ecological and socio-economical bases of the eastern
            hill region based on farmers oriented, problem based, participatory,
            holistic and systematic research; and maintaining effective
            coordination and linkages with the concerned stakeholders for the
            economy growth and improved living standard of farm community.
          </p>
        </div>
      </div>
      <div className="research">
        <div className="title">
          Approach and network for technology transfer
        </div>
        <div className="paragraph">
          <p>
            1. Network mechanisms for technology transfer and information
            sharing has been established with national and regional agricultural
            research stations, disciplinary divisions, Department of
            Agriculture, Department of Livestock Services, Regional Agriculture
            and Livestock Services Directorates of eastern region, Krishi Gyan
            Kendra and Livestock Health Hospital and Bigya Kendra of eastern
            hill region, Rural Municipality and Municipality of respective
            districts, NGO/INGO and CBOs. <br />
            <br />
            2. Technology generating, validating and up-scaling are carried out
            through its outreach research sites established in the research
            command districts representing different agro-ecological domains.
            <br />
          </p>
        </div>
      </div>
      {/* <div className="research">
        <div className="title">{language.key.introductionPage.whyisnirc}</div>
        <div className="paragraph">
          <p>{language.key.introductionPage.whynircdesc}</p>
        </div>
      </div> */}
      <div className="research">
        <div className="title">Infrastructures and services</div>
        <div className="paragraph">
          <p>
            1. Well-equipped laboratories of soil science, plant protection,
            plant tissue culture, seed and veterinary.
            <br />
            2. Training and conference hall.
            <br />
            3. Meteorological station
            <br />
            4. Library and Guest houses.
            <br />
          </p>
        </div>
      </div>

      <div className="research">
        <div className="title">Major Achievements</div>
      </div>

      <div className="research">
        <div className="title">Agronomy</div>
        <div className="paragraph">
          <p>
            1. Determination of appropriate varieties of maize, rice, wheat,
            finger millet, lentil and soyabean. <br />
            <br />
            2. Production and supply of foundation seed of maize (Manakamana-3,
            Manakamana-1, Ganesh, Poshilo Makai-1, Deuti), wheat (WK-1204), rice
            (Khumal-4), Finger millet, etc.
            <br />
          </p>
        </div>
      </div>
      <div className="research">
        <div className="title">Horticulture</div>
        <div className="paragraph">
          <p>
            1. Variety selection and maintenance of Orthodox tea.
            <br />
            2. Tissue culture propagation protocol developed.
            <br />
            3. Technology for rhizome rot management of large cardamom
            developed.
            <br />
            4. Selection and maintenance of large cardamom cultivars.
            <br />
            5. Production and supply of virus free planting material of large
            cardamom.
            <br />
            6. Technology for off- season vegetable production developed.
            <br />
            7. Akabare chilli and their disease and pest management.
            <br />
          </p>
        </div>
      </div>
    </div>
  );
};
